module.exports = __webpack_public_path__ + "img/Icon-ForcedAPC@2x.012065cd.png";